import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_HOST;

async function getConfig(){
  const { data } = await axios.get(`${API_HOST}/v1/config`);
  return { data };
}

async function syncConfig() {
  const { data } = await axios.get(`${API_HOST}/v1/config/sync`);
  return data;
}

async function getAttribute(id: string) {
  const { data } = await axios.get(`${API_HOST}/v1/config/attribute/${id}`);
  return data;
}

async function updateConfig(updateData: Record<string, unknown>) {
  const { data } = await axios.patch(`${API_HOST}/v1/config`, updateData);
  return data;
}

const configManagement = {
  getConfig,
  syncConfig,
  getAttribute,
  updateConfig,
};

export default configManagement;